import store from '@/plugins/vuex'

const routes = [
  {
    path: '/label/my-videos',
    name: 'My Videos Label',
    component: () =>
      import(/* webpackChunkName: 'my-videos-label' */ './views/Index.vue')
  }
]

export default routes
